import type { Tokens } from '@/interfaces/jwt'
import { axiosInstance } from '@/lib/api'

type LoginDto = {
  email: string
  password: string
}

type RegisterDto = {
  name: string
  email: string
  password: string
}

type ForgotPasswordDto = {
  email: string
}

type ResetPasswordDto = {
  email: string
  tempPassword: string
  password: string
}

export class AuthService {
  public static async login(payload: LoginDto) {
    const { data } = await axiosInstance.post<Tokens>('/auth/login', payload)
    return data
  }

  public static async register(payload: RegisterDto) {
    const { data } = await axiosInstance.post<Tokens>('/auth/sign-up', payload)
    return data
  }

  public static async forgotPassword(payload: ForgotPasswordDto) {
    const { data } = await axiosInstance.post('/auth/forgot-password', payload)
    return data
  }

  public static async resetPassword(payload: ResetPasswordDto) {
    const { data } = await axiosInstance.post<Tokens>(
      '/auth/reset-password',
      payload
    )
    return data
  }
}
